import { Link, useLocation } from "react-router-dom";

export default function Sidebar() {
  const { pathname } = useLocation();

  const menu = [
    {
      title: "Dashboard",
      path: "/dashboard",
      icon: DashboardIcon
    },
    {
      title: "Monitoring",
      icon: MonitorIcon,
      children: [
        {
          title: "Monitoring Harian",
          path: "/monitoring"
        },
        {
          title: "Jurnal Makan",
          path: "/monitoring/jurnal-makan"
        }
      ]
    },
    {
      title: "Data Ibu",
      path: "/ibu",
      icon: UserGroupIcon
    },
    {
      title: "Laporan Mingguan",
      path: "/reports/weekly",
      icon: ChartIcon
    },
    {
      title: "Staff",
      path: "/staff",
      icon: ShieldIcon
    }
  ];

  return (
    <aside className="w-64 bg-gradient-to-b from-purple-600 to-indigo-700 text-white min-h-screen flex flex-col shadow-xl">
      {/* ================= BRAND ================= */}
      <div className="px-6 py-6 border-b border-white/10">
        <h1 className="text-2xl font-extrabold tracking-wide">
          SITIKOM
        </h1>
        <p className="text-sm text-purple-200 mt-1">
          Admin Dashboard
        </p>
      </div>

      {/* ================= MENU ================= */}
      <nav className="flex-1 px-3 py-5 space-y-2">
        {menu.map((item, idx) => {
          const Icon = item.icon;

          // ===== MENU DENGAN SUBMENU =====
          if (item.children) {
            const activeParent = item.children.some(c =>
              pathname.startsWith(c.path)
            );

            return (
              <div key={idx} className="space-y-1">
                {/* PARENT */}
                <div
                  className={`
                    flex items-center gap-4 px-4 py-3 rounded-xl
                    ${
                      activeParent
                        ? "bg-white text-purple-700 shadow-lg font-semibold"
                        : "text-purple-100"
                    }
                  `}
                >
                  <Icon
                    className={`w-5 h-5 ${
                      activeParent ? "text-purple-600" : "text-purple-200"
                    }`}
                  />
                  <span className="text-sm tracking-wide">
                    {item.title}
                  </span>
                </div>

                {/* SUB MENU */}
                <div className="ml-6 space-y-1">
                  {item.children.map(sub => {
                    const active = pathname === sub.path;

                    return (
                      <Link
                        key={sub.path}
                        to={sub.path}
                        className={`
                          block px-4 py-2 rounded-lg text-sm transition
                          ${
                            active
                              ? "bg-white/90 text-purple-700 font-semibold"
                              : "text-purple-200 hover:bg-white/10"
                          }
                        `}
                      >
                        {sub.title}
                      </Link>
                    );
                  })}
                </div>
              </div>
            );
          }

          // ===== MENU NORMAL =====
          const active = pathname.startsWith(item.path!);

          return (
            <Link
              key={item.path}
              to={item.path!}
              className={`
                group relative flex items-center gap-4 px-4 py-3 rounded-xl transition-all duration-200
                ${
                  active
                    ? "bg-white text-purple-700 shadow-lg font-semibold"
                    : "text-purple-100 hover:bg-white/10"
                }
              `}
            >
              {active && (
                <span className="absolute left-0 top-1/2 -translate-y-1/2 h-6 w-1 bg-purple-600 rounded-r-full" />
              )}

              <item.icon
                className={`w-5 h-5 ${
                  active
                    ? "text-purple-600"
                    : "text-purple-200 group-hover:text-white"
                }`}
              />

              <span className="text-sm tracking-wide">
                {item.title}
              </span>
            </Link>
          );
        })}
      </nav>

      {/* ================= FOOTER ================= */}
      <div className="px-4 py-4 text-xs text-purple-200 border-t border-white/10">
        © {new Date().getFullYear()} SITIKOM
      </div>
    </aside>
  );
}

/* =========================
   ICONS
========================= */

function DashboardIcon(props: any) {
  return (
    <svg {...props} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round"
        d="M3 13.5V6.75A2.25 2.25 0 015.25 4.5h3.5A2.25 2.25 0 0111 6.75v6.75m0 0V17.25A2.25 2.25 0 0113.25 19.5h3.5A2.25 2.25 0 0119 17.25V13.5m-8 0h8" />
    </svg>
  );
}

function MonitorIcon(props: any) {
  return (
    <svg {...props} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round"
        d="M3.75 6.75h16.5v9H3.75v-9zM9 19.5h6" />
    </svg>
  );
}

function UserGroupIcon(props: any) {
  return (
    <svg {...props} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round"
        d="M15 19.5H9m6-6a3 3 0 11-6 0 3 3 0 016 0zm6 6a6 6 0 00-12 0" />
    </svg>
  );
}

function ChartIcon(props: any) {
  return (
    <svg {...props} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round"
        d="M3 3v18h18M7.5 15V9m4.5 6V6m4.5 9v-3" />
    </svg>
  );
}

function ShieldIcon(props: any) {
  return (
    <svg {...props} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round"
        d="M12 3l7.5 3v6c0 5.25-3.75 8.25-7.5 9-3.75-.75-7.5-3.75-7.5-9V6L12 3z" />
    </svg>
  );
}
